module.exports = __webpack_public_path__ + "7ab86d4d6597126e9065122186e263f1.svg";